import { DEVICE_CONTEXT_MENU_SERVICE_NAME, DeviceContextMenuServiceProvider } from './device.context-menu.service'
import { DEVICE_SERVICE_NAME, DeviceServiceProvider } from './device.service'

export const DEVICE_SERVICES_MODULE_NAME = 'simax.services.device'

const locationServicesModule = angular.module(DEVICE_SERVICES_MODULE_NAME, [])

locationServicesModule.provider(DEVICE_CONTEXT_MENU_SERVICE_NAME, DeviceContextMenuServiceProvider)
locationServicesModule.provider(DEVICE_SERVICE_NAME, DeviceServiceProvider)
